import React, { Component } from 'react';
import {BrowserRouter,HashRouter, Route, Switch,Redirect} from 'react-router-dom'
import './styles/App.css';
import Home from './components/Home'
import CheckOut from './components/Recipe'
import Cart from './components/Cart'
import Start from './components/Start'
import Diningdollar from './components/Diningdollar'
import Confirm from './components/Confirm'




class App extends Component {
  render() {
    return (
     
       <HashRouter basename="/" >
       
            <div className="App">
             
            {localStorage.getItem('idOrder') ? (<Redirect to='/Confirm' />):(<label></label>)}
             
             
                <Switch>
                  <Route exact path="/" component={Start}/> 
                    <Route  exact path="/home" render={(props) => <Home {...props} isAuthed={false} />}/>
                    <Route path="/cart" props  component={Cart}/>
                    <Route path="/confirm" component={Confirm}/>
                    <Route path="/checkout" component={CheckOut}/>
                    <Route path="/diningdollar" component={Diningdollar}/>
                   
                  </Switch>
               
             </div>
       </HashRouter>
      
    );
  }
}

export default App;
